var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-field-resizable",
      class: { "resizable-textarea": _vm.textarea }
    },
    [
      _c(
        "m-text-field",
        _vm._g(
          _vm._b(
            {
              attrs: {
                autofocus: _vm.autofocus,
                type: _vm.type,
                textarea: _vm.textarea,
                "use-native-validation": false
              },
              on: {
                change: function($event) {
                  return _vm.$emit("update:value", _vm.textVal)
                },
                keydown: _vm.handleKeydown,
                keyup: function($event) {
                  return _vm.$emit("update:value", _vm.textVal)
                }
              },
              model: {
                value: _vm.textVal,
                callback: function($$v) {
                  _vm.textVal = $$v
                },
                expression: "textVal"
              }
            },
            "m-text-field",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.leadingIcon
            ? _c("m-icon", {
                staticClass: "leading-icon",
                attrs: { slot: "leadingIcon", icon: _vm.leadingIcon },
                slot: "leadingIcon"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.trailingIcon
            ? _c("m-icon", {
                staticClass: "trailing-icon",
                attrs: { slot: "trailingIcon", icon: _vm.trailingIcon },
                slot: "trailingIcon"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.label
            ? _c("m-floating-label", [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.helper
        ? _c(
            "m-text-field-helper-text",
            {
              attrs: {
                "validation-msg": _vm.validationMsg,
                persistent: _vm.persistent
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.helper) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }